import { render, staticRenderFns } from "./GitControl.vue?vue&type=template&id=6470ab77&scoped=true"
import script from "./GitControl.vue?vue&type=script&lang=js"
export * from "./GitControl.vue?vue&type=script&lang=js"
import style0 from "./GitControl.vue?vue&type=style&index=0&id=6470ab77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6470ab77",
  null
  
)

export default component.exports